<template>
	<button
		class="product-info-like link link--md"
		type="button"
		:class="{ 'product-info-like--active': isActive }"
		@click="handleClick"
	>
		<span class="product-info-like__name product-info-like__name--inactive">В избранное</span>
		<span class="product-info-like__name product-info-like__name--active">В избранном</span>
	</button>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
	id: string;
}

const props = defineProps<Props>();

const { store } = window.app;
const isActive = computed(() => store.isInFavourites(props.id));

const handleClick = (): void => {
	store.setFavourite(props.id);
};
</script>
